import { useScrollRestoration } from '@srcDS/hooks/useScrollRestoration';

export const useScrollPosition = (isSSR: boolean) => {
  const { registerScrollPosition } = useScrollRestoration({
    isSSR,
    disable: false,
  });

  return (ref: React.RefObject<HTMLElement>) => {
    registerScrollPosition({
      element: ref.current,
    });
  };
};